import { Blocks, Image, Images, Layers, LayoutTemplate, Palette, Shapes, Sparkles, Type } from 'lucide-react';
import React, { FC } from 'react';

import { ToolButton, ToolRailWrapper } from './Editor.styled';

export type EditorTool = 'ai' | 'templates' | 'text' | 'elements' | 'shapes' | 'images' | 'stock' | 'background' | 'layers';

const TOOLS: { id: EditorTool; label: string; icon: typeof Type }[] = [
  { id: 'templates', label: 'Szablony', icon: LayoutTemplate },
  { id: 'text', label: 'Tekst', icon: Type },
  { id: 'elements', label: 'Elementy', icon: Blocks },
  { id: 'shapes', label: 'Kształty', icon: Shapes },
  { id: 'images', label: 'Zdjęcia', icon: Image },
  { id: 'stock', label: 'Magnific', icon: Images },
  { id: 'background', label: 'Tło', icon: Palette },
  { id: 'layers', label: 'Warstwy', icon: Layers },
  { id: 'ai', label: 'AI', icon: Sparkles },
];

interface ToolRailProps {
  active: EditorTool;
  onChange: (tool: EditorTool) => void;
}

export const ToolRail: FC<ToolRailProps> = ({ active, onChange }) => (
  <ToolRailWrapper aria-label="Narzędzia">
    {TOOLS.map(({ id, label, icon: Icon }) => (
      <ToolButton key={id} type="button" $active={active === id} onClick={() => onChange(id)}>
        <Icon size={18} />
        {label}
      </ToolButton>
    ))}
  </ToolRailWrapper>
);
